import { Heart } from 'lucide-react';
import { Link } from 'react-router-dom';
import { Button } from '../components/ui/button';
import { ProductCard } from '../components/ProductCard';
import { useWishlist } from '../context/WishlistContext';

export default function WishlistPage() {
  const { wishlist, loading } = useWishlist();

  if (loading) {
    return (
      <div className="bg-white rounded-3xl p-6 md:p-8">
        <div className="animate-pulse space-y-4">
          <div className="h-8 bg-surface rounded-xl w-1/3" />
          <div className="grid grid-cols-2 gap-4">
            <div className="aspect-square bg-surface rounded-2xl" />
            <div className="aspect-square bg-surface rounded-2xl" />
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="bg-white rounded-3xl p-6 md:p-8" data-testid="wishlist-page">
      <h1 className="font-heading text-2xl md:text-3xl text-secondary mb-6">My Wishlist</h1>

      {wishlist.items.length === 0 ? (
        <div className="text-center py-12">
          <Heart className="w-16 h-16 mx-auto mb-4 text-muted-foreground" />
          <h2 className="font-heading text-xl text-secondary mb-2">Your Wishlist is Empty</h2>
          <p className="text-muted-foreground font-body mb-6">
            Save items you love to your wishlist
          </p>
          <Button asChild className="rounded-full bg-primary">
            <Link to="/">Explore Products</Link>
          </Button>
        </div>
      ) : (
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6">
          {wishlist.items.map((product) => (
            <ProductCard key={product.product_id} product={product} />
          ))}
        </div>
      )}
    </div>
  );
}
